import { render, staticRenderFns } from "./smsBtn.vue?vue&type=template&id=2d2d068b&"
import script from "./smsBtn.vue?vue&type=script&lang=js&"
export * from "./smsBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports